
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/[vendorId]/overview",
      function () {
        return require("private-next-pages/dashboard/[vendorId]/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/[vendorId]/overview"])
      });
    }
  